import React from "react";
import { Modal } from "react-bootstrap";
import styles from "../../_css/DeleteUserModal.module.css";
import { CustomButtonLight } from "../UI/CustomButtons";
import _ from "lodash";
import { START_CHAT_MODAL, PLAN_ERROR_MESSAGE } from "../../data/modelsData";
import { useSelector } from "react-redux";
import { deleteAuthToken, notifyError } from "../../utils/helper";
import { checkAccountStatus } from "../../requests";

const StartChat = ({ show, onHide, onTextHandle, onVoiceHandle }) => {
  const userInfo = JSON.parse(sessionStorage.getItem("sal_userInfo"));
  const isPremium = _.lowerCase(userInfo?.subscription_type) === "premium";
  const lang = useSelector((state) => state.language.lang);
  const { title, btnText } = START_CHAT_MODAL[lang];

  const message = PLAN_ERROR_MESSAGE[lang];

  const handleStartChat = async (type = "text") => {
    try {
      const response = await checkAccountStatus();
      if (response.status === 200) {
        if (type === "text") {
          onTextHandle();
        } else {
          if (!isPremium) {
            notifyError(message);
          } else {
            onVoiceHandle();
          }
        }
      } else {
        notifyError(response.data.message[lang]);
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        deleteAuthToken();
        window.location.reload();
      } else if (error?.response?.status === 400) {
        notifyError(error?.response?.data?.message[lang]);
      }
    }
  };
  const handleVoiceHandle = () => {
    if (!isPremium) {
      notifyError(message);
    } else {
      onVoiceHandle();
    }
  };

  return (
    <Modal
      className={styles.startChatModal}
      show={show}
      onHide={onHide}
      centered
      size="sm"
      style={{
        direction: lang == "ar" ? "rtl" : "ltr",
      }}
    >
      <Modal.Header className={" p-3 py-2"} closeButton>
        <Modal.Title
          style={{
            fontSize: "20px",
            fontWeight: "600",
            color: "var(--color-1)",
          }}
        >
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center p-3 pt-0 pb-3">
        <div
          className={
            styles.buttonRow + " d-flex justify-content-center gap-3 mt-4"
          }
        >
          <CustomButtonLight
            text={btnText[0]}
            onClick={() => handleStartChat("text")}
            width="100%"
            icon="text"
          />
          <CustomButtonLight
            text={btnText[1]}
            onClick={() => handleStartChat("voice")}
            width="100%"
            icon="voice"
            // disabled={!isPremium}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default StartChat;
